import { notificationsConfig } from "../config/notifications.config.js";

/**
 * Normaliza query `limit` para `GET /notifications`.
 * @param {number|string} [limit]
 * @returns {number}
 */
export function normalizeNotificationsListLimit(limit) {
  const { defaultLimit, minLimit, maxLimit } = notificationsConfig;
  const parsed = Number(limit);

  if (!Number.isFinite(parsed)) return defaultLimit;

  const truncated = Math.trunc(parsed);
  if (truncated < minLimit) return defaultLimit;
  if (truncated > maxLimit) return maxLimit;
  return truncated;
}

/**
 * Extrai array bruto de notificações do envelope da API.
 * @param {*} response
 * @returns {Array}
 */
export function extractNotificationsList(response) {
  if (Array.isArray(response?.notifications)) {
    return response.notifications;
  }
  if (Array.isArray(response?.data?.notifications)) {
    return response.data.notifications;
  }
  if (Array.isArray(response?.data)) {
    return response.data;
  }
  if (Array.isArray(response)) {
    return response;
  }
  return [];
}

/** Extrai o total de não lidas do envelope da API. */
export function extractNotificationsUnreadCount(response) {
  const raw = response?.unreadCount ?? response?.data?.unreadCount;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0) return null;
  return Math.trunc(parsed);
}

/** Extrai o cursor de próxima página do envelope da API. */
export function extractNextCursor(response) {
  const raw = response?.nextCursor ?? response?.data?.nextCursor;
  return typeof raw === "string" && raw.trim() ? raw.trim() : null;
}
